export default "__VITE_ASSET__b3a190b5__"